import React, { useState, useEffect } from "react"
import { View } from "react-native"
import { connect } from "react-redux"
import { ModalSkeleton } from "@common/modals/ModalSkeleton"
import UncontrolledTextInputM from "@common/components/input/UncontrolledTextInputM"
import FilledButtonM from "@common/components/button/FilledButtonM"
import { theme } from "@common/theme/theme"
import { apiRequest, apiIdle } from "@data/redux/actions/api"
import { activitiesService } from "@data/services/activitiesService"
import { useApiStatus } from "@common/hooks/useApiStatus"
import { SnackBarM } from "@common/components/alert/snackbar/SnackBar"
import useLiveKitEventSender from "@common/hooks/livekit/useLiveKitEventSender"

const EditActivityTitleModal = (props) => {
    const { isVisible, onClose, activity } = props
    const [title, setTitle] = useState("")
    const { sendLiveKitData: sendUpdate } = useLiveKitEventSender()

    // Initialize title when modal opens
    useEffect(() => {
        if (isVisible && activity) {
            const currentTitle = activity?.material?.title ?? activity?.title ?? ""
            setTitle(currentTitle)
        }
    }, [isVisible, activity])

    // Handle API success
    useApiStatus(
        activitiesService.updateActivityTodo,
        null,
        true,
        (data) => {
            SnackBarM.show({
                text1: "✅ Titre modifié avec succès",
                duration: 3000,
            })

            // Notify student via LiveKit (only during live sessions)
            const sid = activity?.student_id
            if (sid && props.isLiveMode) {
                sendUpdate("newTodo", { id: sid, activity: data }, [sid])
            }

            // Close modal
            handleClose()
        }
    )

    const handleSave = () => {
        if (!title?.trim()) {
            SnackBarM.show({
                text1: "⚠️ Le titre ne peut pas être vide",
                duration: 3000,
            })
            return
        }

        // Use JSON instead of FormData for simple string field
        const data = {
            material_title: title.trim()
        }

        props.apiRequest(
            activitiesService.updateActivityTodo,
            { id: activity?.id },
            data
        )
    }

    const handleClose = () => {
        // Reset API state to clear loading
        props.apiIdle(activitiesService.updateActivityTodo)

        // Reset local state
        setTitle("")

        // Call parent close handler
        onClose()
    }

    // Reset state when modal closes
    useEffect(() => {
        if (!isVisible) {
            props.apiIdle(activitiesService.updateActivityTodo)
            setTitle("")
        }
    }, [isVisible])

    const isLoading = props.updateActivityTodoRequest

    return (
        <ModalSkeleton
            isVisible={isVisible}
            onClose={!isLoading ? handleClose : undefined}
            title="Modifier le titre"
        >
            <View style={{ paddingTop: 8 }}>
                <UncontrolledTextInputM
                    label="Titre de l'activité"
                    value={title}
                    onChangeText={setTitle}
                    placeholder="Entrer le titre..."
                    mode="outlined"
                    outlineColor={theme.colors.lightMore}
                    activeOutlineColor={theme.colors.primary}
                    style={{
                        marginBottom: 20,
                        backgroundColor: theme.colors.white,
                    }}
                    disabled={isLoading}
                    autoFocus={!isLoading}
                />

                <FilledButtonM
                    label="Enregistrer"
                    icon="check"
                    onPress={handleSave}
                    disabled={!title?.trim() || isLoading}
                    loading={isLoading}
                    style={{ marginBottom: 8, width: "100%" }}
                />
            </View>
        </ModalSkeleton>
    )
}

const mapStateToProps = (state) => ({
    updateActivityTodoRequest: state.api.updateActivityTodo?.request,
    isLiveMode: state.liveMode?.isLiveModeEnabled,
})

const mapDispatchToProps = {
    apiRequest,
    apiIdle,
}

export default connect(mapStateToProps, mapDispatchToProps)(EditActivityTitleModal)
